function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-chevron-circle-up_svg__a",
  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0-2c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm-.707 8.293l-4 4a.997.997 0 000 1.414.999.999 0 001.414 0L12 10.414l3.293 3.293a.999.999 0 101.414-1.414l-4-4a.999.999 0 00-1.414 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-chevron-circle-up_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-chevron-circle-up_svg__a"
})), React.createElement("use", {
  xlinkHref: "#icon-chevron-circle-up_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-chevron-circle-up_svg__b)"
}, React.createElement("path", {
  d: "M24 0H0v24h24z"
})));

var SvgIconChevronCircleUp = function SvgIconChevronCircleUp(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconChevronCircleUp;